export enum ContractType {
	Standard = 1,
	Panel = 2,
}

export enum RequisitionType {
	Normal = 1,
	Emergency = 2,
}

export enum AccommodationType {
	Hotel = 1,
	BnB = 2,
}

export enum FlightTicketType {
	Flexible = 1,
	NonFlexible = 2,
}

export enum PurchaseType {
	Standard = 1,
	Contract = 2,
}

export enum RequisitionStepHistoryStatus {
	Completed = "Completed",
	Ready = "Ready",
	Pending = "Pending",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
	Deleted = "Deleted",
	Delegated = "Delegated",
	Escalated = "Escalated",
	Cancelled = "Cancelled",
}

export enum RequisitionStepHistoryStatusId {
	Completed = 1,
	Ready = 2,
	Pending = 3,
	Recalled = 4,
	ChangeRequested = 5,
	Rejected = 6,
	Deleted = 7,
	Delegated = 8,
	Escalated = 9,
	Cancelled = 10,
}

export enum ContractTransactionTypeId {
	NewContract = 1,
	ContractExtension = 2,
	ContractRequisition = 3, // displayName = "Contract Purchase Order"
	ContractInventoryTransfer = 7,
	NewPanel = 4,
	PanelExtension = 5,
	PanelRequisition = 6, // displayName = "Panel Purchase Order"
	StandardPurchase = 8,
}

export enum EstimationLogicType {
	Average = 1,
	Least = 2,
}

export enum ItemSourcingType {
	Combined = 1,
	Split = 2,
}

export enum ShuttleTripType {
	Single = 1,
	Multiple = 2,
}

export enum ReqTravelCategory {
	Flight = "Flight",
	Accommodation = "Accommodation",
	CarHire = "CarHire",
	Shuttle = "Shuttle",
	Default = "",
}
